module.exports = __webpack_public_path__ + "static/media/dg.32b2c1e7.svg";